// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TopLeaderboard_podium-container__jPxRC {
  /* --_podium-size: 4px; */
  --_podium-size: 8.5px;
  perspective: calc(var(--_podium-size) * 50);
  margin-top: calc(var(--_podium-size) * 16);
  display: grid;
  place-items: center;
}
@media only screen and (max-width: 440px) {
  .TopLeaderboard_podium-container__jPxRC {
    --_podium-size: 6.5px;
  }
  .TopLeaderboard_podium__image__8H17k > .TopLeaderboard_card__Lwn0x {
    height: calc(var(--_podium-size) * 21) !important;
    width: calc(var(--_podium-size) * 16) !important;
  }
  .TopLeaderboard_card__Lwn0x img {
    width: 35px !important;
  }
}
/* @media only screen and (min-width: 960px) {
  .podium-container {
    --_podium-size: 10px;
  }
} */

.TopLeaderboard_podium__PiE8d {
  display: grid;
  align-items: end;
  grid-template-columns: repeat(3, 1fr);
  transform-style: preserve-3d;
  /* font-size: calc(var(--_podium-size) * 12); */
  font-size: calc(var(--_podium-size) * 8);
  font-weight: 900;
  /* gap: 12px; */
  gap: 10px;
  /* transform: rotateX(-40deg); */
  transform: rotateX(-20deg);
  text-align: center;
}

.TopLeaderboard_podium__front__8vDxw {
  padding-inline: calc(var(--_podium-size) * 5);
  padding-bottom: calc(var(--_podium-size) * 3);
  position: relative;
  transform-style: preserve-3d;
  transform-origin: top;
  transition: transform 0.25s;
}

.TopLeaderboard_podium__front__8vDxw:hover {
  transform: translate3d(0, 0, 15px);
}

.TopLeaderboard_podium__center__SOxxu {
  transform: translate3d(0, 0, 5px);
}

.TopLeaderboard_podium__center__SOxxu:hover {
  transform: translate3d(0, 0, 20px);
}

.TopLeaderboard_podium__front__8vDxw::after {
  transform-style: preserve-3d;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform-origin: top;
  transform: rotatex(-90deg);
}

.TopLeaderboard_podium__left__788ky::before,
.TopLeaderboard_podium__right__CfoMs::before {
  /* background: #430201; */
  background: linear-gradient(to left, #430201, #960100);
  transform-style: preserve-3d;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform-origin: right;
  transform: rotatey(-90deg);
}

.TopLeaderboard_podium__right__CfoMs::before {
  background: linear-gradient(to right, #430201, #960100);
  transform-origin: left;
  transform: rotatey(90deg);
}

.TopLeaderboard_podium__left__788ky {
  padding-top: calc(var(--_podium-size) * 3);
  background: var(--main-color);
}

.TopLeaderboard_podium__left__788ky::after {
  /* background: #780302; */
  background: linear-gradient(#780302, transparent);
}

.TopLeaderboard_podium__center__SOxxu {
  padding-top: calc(var(--_podium-size) * 5);
  background: #ad0504;
}

.TopLeaderboard_podium__center__SOxxu::after {
  background: var(--main-color);
  background: linear-gradient(#980100, transparent);
}

.TopLeaderboard_podium__right__CfoMs {
  padding-top: calc(var(--_podium-size) * 1);
  background: #960302;
}

.TopLeaderboard_podium__right__CfoMs::after {
  background: #780201;
  background: linear-gradient(#780201, transparent);
}

.TopLeaderboard_podium__image__8H17k {
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, -80%) translatez(-55px) rotatey(0);
  transform-style: preserve-3d;
  transform-origin: center;
}

/* .podium__image > img {
  width: calc(var(--_podium-size) * 10);
} */
.TopLeaderboard_podium__image__8H17k > .TopLeaderboard_card__Lwn0x {
    height: calc(var(--_podium-size) * 19);
    width: calc(var(--_podium-size) * 14);
    background-color: #fbfbfb;
    border: 1px solid #0000001b;
    border-radius: 5px;
    box-shadow: 3px -3px 6px #b3b3b35c;
}
.TopLeaderboard_card__Lwn0x img {
    width: 40px;
    margin: auto;
}

.TopLeaderboard_card__Lwn0x p {
    font-size: 9px;
    color: #242424;
    font-weight: 400;
    letter-spacing: 0.7px;
    padding: 2px 0;
}

.TopLeaderboard_podium__image__8H17k::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: calc(var(--_podium-size) * 6);
  border-radius: 100%;
  filter: blur(20px);
  background: #0e1303;
  background: linear-gradient(#0e1303, transparent);
  transform: rotatex(90deg);
}

.TopLeaderboard_podium__front__8vDxw:hover > .TopLeaderboard_podium__image__8H17k {
  animation: TopLeaderboard_rotate__qUOrF 10s linear infinite;
}

@keyframes TopLeaderboard_rotate__qUOrF {
  to {
    transform: translate(-50%, -80%) translateZ(-55px) rotateY(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/TopLeaderboard.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;EAC3C,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;AACrB;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,iDAAiD;IACjD,gDAAgD;EAClD;EACA;IACE,sBAAsB;EACxB;AACF;AACA;;;;GAIG;;AAEH;EACE,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,+CAA+C;EAC/C,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,6CAA6C;EAC7C,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,sDAAsD;EACtD,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,uDAAuD;EACvD,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,6DAA6D;EAC7D,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;;GAEG;AACH;IACI,sCAAsC;IACtC,qCAAqC;IACrC,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;IAClB,kCAAkC;AACtC;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA;EACE,2DAAqC;AACvC;;AAEA;EACE;IACE,kEAAkE;EACpE;AACF","sourcesContent":[".podium-container {\n  /* --_podium-size: 4px; */\n  --_podium-size: 8.5px;\n  perspective: calc(var(--_podium-size) * 50);\n  margin-top: calc(var(--_podium-size) * 16);\n  display: grid;\n  place-items: center;\n}\n@media only screen and (max-width: 440px) {\n  .podium-container {\n    --_podium-size: 6.5px;\n  }\n  .podium__image > .card {\n    height: calc(var(--_podium-size) * 21) !important;\n    width: calc(var(--_podium-size) * 16) !important;\n  }\n  .card img {\n    width: 35px !important;\n  }\n}\n/* @media only screen and (min-width: 960px) {\n  .podium-container {\n    --_podium-size: 10px;\n  }\n} */\n\n.podium {\n  display: grid;\n  align-items: end;\n  grid-template-columns: repeat(3, 1fr);\n  transform-style: preserve-3d;\n  /* font-size: calc(var(--_podium-size) * 12); */\n  font-size: calc(var(--_podium-size) * 8);\n  font-weight: 900;\n  /* gap: 12px; */\n  gap: 10px;\n  /* transform: rotateX(-40deg); */\n  transform: rotateX(-20deg);\n  text-align: center;\n}\n\n.podium__front {\n  padding-inline: calc(var(--_podium-size) * 5);\n  padding-bottom: calc(var(--_podium-size) * 3);\n  position: relative;\n  transform-style: preserve-3d;\n  transform-origin: top;\n  transition: transform 0.25s;\n}\n\n.podium__front:hover {\n  transform: translate3d(0, 0, 15px);\n}\n\n.podium__center {\n  transform: translate3d(0, 0, 5px);\n}\n\n.podium__center:hover {\n  transform: translate3d(0, 0, 20px);\n}\n\n.podium__front::after {\n  transform-style: preserve-3d;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  transform-origin: top;\n  transform: rotatex(-90deg);\n}\n\n.podium__left::before,\n.podium__right::before {\n  /* background: #430201; */\n  background: linear-gradient(to left, #430201, #960100);\n  transform-style: preserve-3d;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  transform-origin: right;\n  transform: rotatey(-90deg);\n}\n\n.podium__right::before {\n  background: linear-gradient(to right, #430201, #960100);\n  transform-origin: left;\n  transform: rotatey(90deg);\n}\n\n.podium__left {\n  padding-top: calc(var(--_podium-size) * 3);\n  background: var(--main-color);\n}\n\n.podium__left::after {\n  /* background: #780302; */\n  background: linear-gradient(#780302, transparent);\n}\n\n.podium__center {\n  padding-top: calc(var(--_podium-size) * 5);\n  background: #ad0504;\n}\n\n.podium__center::after {\n  background: var(--main-color);\n  background: linear-gradient(#980100, transparent);\n}\n\n.podium__right {\n  padding-top: calc(var(--_podium-size) * 1);\n  background: #960302;\n}\n\n.podium__right::after {\n  background: #780201;\n  background: linear-gradient(#780201, transparent);\n}\n\n.podium__image {\n  position: absolute;\n  top: 0%;\n  left: 50%;\n  transform: translate(-50%, -80%) translatez(-55px) rotatey(0);\n  transform-style: preserve-3d;\n  transform-origin: center;\n}\n\n/* .podium__image > img {\n  width: calc(var(--_podium-size) * 10);\n} */\n.podium__image > .card {\n    height: calc(var(--_podium-size) * 19);\n    width: calc(var(--_podium-size) * 14);\n    background-color: #fbfbfb;\n    border: 1px solid #0000001b;\n    border-radius: 5px;\n    box-shadow: 3px -3px 6px #b3b3b35c;\n}\n.card img {\n    width: 40px;\n    margin: auto;\n}\n\n.card p {\n    font-size: 9px;\n    color: #242424;\n    font-weight: 400;\n    letter-spacing: 0.7px;\n    padding: 2px 0;\n}\n\n.podium__image::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: calc(var(--_podium-size) * 6);\n  border-radius: 100%;\n  filter: blur(20px);\n  background: #0e1303;\n  background: linear-gradient(#0e1303, transparent);\n  transform: rotatex(90deg);\n}\n\n.podium__front:hover > .podium__image {\n  animation: rotate 10s linear infinite;\n}\n\n@keyframes rotate {\n  to {\n    transform: translate(-50%, -80%) translateZ(-55px) rotateY(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"podium-container": `TopLeaderboard_podium-container__jPxRC`,
	"podium__image": `TopLeaderboard_podium__image__8H17k`,
	"card": `TopLeaderboard_card__Lwn0x`,
	"podium": `TopLeaderboard_podium__PiE8d`,
	"podium__front": `TopLeaderboard_podium__front__8vDxw`,
	"podium__center": `TopLeaderboard_podium__center__SOxxu`,
	"podium__left": `TopLeaderboard_podium__left__788ky`,
	"podium__right": `TopLeaderboard_podium__right__CfoMs`,
	"rotate": `TopLeaderboard_rotate__qUOrF`
};
export default ___CSS_LOADER_EXPORT___;
